<template>
    <md-list-item target="_blank" :href="getUrlVisor">

      <md-avatar>
        <img src="http://visor.grafcan.es/visorweb/img/logoGOBCAN.gif" alt="Gobierno de Canarias">
      </md-avatar>

      <div class="md-list-text-container">
        <span>{{ data.nombre }}</span>
        <span>{{ data.clasificacion }}</span>
        <p>{{ data.localizacion }}</p>
      </div>

      <md-button class="md-icon-button md-list-action" :href="getUrlKml">
        <md-icon class="md-default">archive</md-icon>
      </md-button>

      <md-divider class="md-inset"></md-divider>

    </md-list-item>

</template>

<script>
export default {
    props: [
        'data'
    ],
    data () {
        return {
        }
    },
    computed: {
        getUrlKml: function () {
            return 'http://visor.grafcan.es/busquedas/toponimiakml/1/10/idecanarias/1/' + this.data.id + '/';
        },
        getUrlVisor: function () {
            return 'http://visor.grafcan.es/visorweb/default.php?svc=svcCallejero&lat=' + this.data.latitud + '&lng=' + this.data.longitud + '&zoom=18&lang=es&mklat=' + this.data.latitud + '&mklng=' + this.data.longitud; // + '&mkurl=http://visor.grafcan.es/busquedas/toponimiakml/1/10/idecanarias/1/' + this.data.id + '/';
        },
    }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/Toponimo.vue